module.exports = __webpack_public_path__ + "img/thumbnail_SomaliWildAss_j_normal.5b4395c6.png";